import { tryParseBoolean } from '@witkac/utils/tryParseBoolean';
import moment from 'moment';
import { Route } from 'vue-router';

import { FINANCIAL_PLAN_TYPE_DEFAULT } from '@/enums/financialPlanType.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { TableName } from '@/enums/tableName';
import store from '@/store/store';

/**
 * Pobiera plan finansowy
 *
 * @export
 * @param {Route} route
 * @returns {Promise<any>}
 */
export function getFinancialPlan(route: Route): Promise<any> {
  return Promise.all([
    store.dispatch('financialPlan/getFinancialPlan', getFinancialPlanFilters(route)),
    store.dispatch('setting/findPublic', {
      code: PublicSettings.FINANCIAL_PLAN_COLUMNS,
      entityType: TableName.procedure,
      entityId: route.params.procedureId.toString()
    })
  ]);
}

/**
 * Zwraca filtry planu finansowego
 *
 * @export
 * @param {Route} route
 * @returns {*}
 */
export function getFinancialPlanFilters(route: Route): any {
  return {
    ...getDates(route),
    procedureId: parseInt(route.params.procedureId),
    planType: route.query.planType || FINANCIAL_PLAN_TYPE_DEFAULT,
    isUkraine: tryParseBoolean(route.query.isUkraine)
  };
}

/**
 * Zwraca przedział dat do filtrów
 *
 * @param {Route} route
 * @returns {{ startDate: string; endDate: string }}
 */
function getDates(route: Route): { startDate: string; endDate: string } {
  return { startDate: getStartDate(route), endDate: getEndDate(route) };
}

/**
 * Zwraca datę początku przedziału z domyślną wartością
 *
 * @param {Route} route
 * @returns {string}
 */
function getStartDate(route: Route): string {
  if (route.query.startDate) {
    return route.query.startDate as string;
  }

  const currentDate = new Date();
  const year = currentDate.getMonth() >= 8 ? currentDate.getFullYear() : currentDate.getFullYear() - 1;
  return moment(`${year}-09-01`).format('YYYY-MM-DD');
}

/**
 * Zwraca datę końca przedziału z domyślną wartością
 *
 * @param {Route} route
 * @returns {string}
 */
function getEndDate(route: Route): string {
  if (route.query.endDate) {
    return route.query.endDate as string;
  }

  const currentDate = new Date();
  const year = currentDate.getMonth() >= 8 ? currentDate.getFullYear() + 1 : currentDate.getFullYear();
  return moment(`${year}-06-30`).format('YYYY-MM-DD');
}
